export const PlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="none"
  >
    <path
      d="M8 3C8 2.44687 7.55312 2 7 2C6.44688 2 6 2.44687 6 3V7.5H1.5C0.946875 7.5 0.5 7.94688 0.5 8.5C0.5 9.05312 0.946875 9.5 1.5 9.5H6V14C6 14.5531 6.44688 15 7 15C7.55312 15 8 14.5531 8 14V9.5H12.5C13.0531 9.5 13.5 9.05312 13.5 8.5C13.5 7.94688 13.0531 7.5 12.5 7.5H8V3Z"
      fill="currentColor"
    />
  </svg>
);
